import { CreateRoute } from "../../CreateRouter";
import { privateRoutes } from "./routes";

export const PrivateRouter = () => CreateRoute(privateRoutes);
